import { render, staticRenderFns } from "./moreTours.vue?vue&type=template&id=a1050ea8&scoped=true"
import script from "./moreTours.vue?vue&type=script&lang=js"
export * from "./moreTours.vue?vue&type=script&lang=js"
import style0 from "./moreTours.vue?vue&type=style&index=0&id=a1050ea8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a1050ea8",
  null
  
)

export default component.exports